import VagaroLogo from "@images/competitors/vagaro.svg";
import FreshaLogo from "@images/competitors/fresha.svg";
import ZenotiLogo from "@images/competitors/zenoti.svg";
import BoulevardLogo from "@images/competitors/boulevard.svg";
import MilanoLogo from "@images/competitors/milano.svg";
import AestheticRecordLogo from "@images/competitors/aestheticrecord.png";
import AestheticsProLogo from "@images/competitors/aestheticspro.png";
import BookerLogo from "@images/competitors/booker.png";
import MeevoLogo from "@images/competitors/meevo.svg";
import RosyLogo from "@images/competitors/rosy.png";
import PhorestLogo from "@images/competitors/phorest.png";
import SquareLogo from "@images/competitors/square.png";

const competitorData = {
  "switch-from-vagaro-now": {
    pageHeader: {
      heading: "Mangomint vs. Vagaro",
      subheading:
        "Mangomint is the #1 rated salon & spa software by Capterra and G2. Here's why it might be the right choice for you.",
    },
    competitor: {
      name: "Vagaro",
      logo: VagaroLogo,
    },
    rows: [
      {
        col1: "Great for",
        col2: "Growing teams needing premium features and functionality",
        col3: "Solopreneurs or small teams on a budget with basic operational needs",
      },
      {
        col1: "Top Features",
        col2: "Premium design and usability. Optimized for speed and efficiency",
        col3: "Wide variety of features, but slow and lacking refinement",
      },
      {
        col1: "Support",
        col2: "U.S. based team with deep expertise. Fully staffed, responding in under 10 minutes",
        col3: "Hard-to-reach, outsourced call center team",
      },
      {
        col1: "Bottom Line",
        col2: "Premium features to <i>actually</i> make you more profit, rated #1 for Ease of Use by G2",
        col3: "Lots of features for a cheap price but with unreliable functionality",
      },
    ],
    table: {
      heading: "Want a deeper dive?",
      subheading: "Here's how Mangomint & Vagaro compare based on real user feedback.",
      mangomintName: "Mangomint",
      competitorName: "Vagaro",
      rows: [
        {
          category: "Overall rating",
          mangomint: { capterra: "4.9", g2: "4.9" },
          competitor: { capterra: "4.7", g2: "4.6" },
        },
        {
          category: "Ease of use",
          mangomint: { capterra: "4.9" },
          competitor: { capterra: "4.6" },
        },
        {
          category: "Customer service",
          mangomint: { capterra: "5.0" },
          competitor: { capterra: "4.6" },
        },
        {
          category: "Pricing",
          mangomint: "Starting at $165-average $245 per month",
          competitor: "Starting at $30-average $120 per month",
        },
        {
          category: "Processing fees",
          mangomint: "In person: 2.45% + 15¢/transaction\nVirtual: 2.90% + 20¢/transaction",
          competitor: "In person: 2.2% + 19¢/transaction\nVirtual: 3.5% + 15¢/transaction",
        },
        {
          category: "Contracts",
          mangomint: {
            desktop: "No contracts & open data ownership-available to you anytime",
            mobile: "No contracts. Open data ownership.",
          },
          competitor: {
            desktop: "No contracts. Vagaro maintains your client data via required client logins",
            mobile: "No contracts. Vagaro maintains your data.",
          },
        },
        {
          category: "Getting started",
          mangomint: {
            desktop: "Free data transfer. Dedicated manager assigned for 1:1 sessions, plus access to Learning Center",
            mobile: "Free data transfer. 1:1 onboarding manager.",
          },
          competitor: {
            desktop: "Free data transfer. Predominantly self-guided set-up through webinars and online courses",
            mobile: "Free data transfer. Self-guided set-up.",
          },
        },
      ],
    },
    quotes: [
      {
        quote:
          "[Mangomint] is extremely intuitive, fast, reliable and totally user friendly. Their online booking allows clients to book straight from your website - making booking easy and streamlined (getting you more appointments)",
        author:
          '<strong>Emily D.</strong> via <a href="https://www.capterra.com/p/187593/Mangomint/#Capterra___6835516" target="_blank" rel="noopener">Capterra</a>',
        authorDescription: "former Vagaro user who switched to Mangomint",
      },
      {
        quote:
          "[Mangomint] transferred all my data from the past 2 years in literally a day. Their customer service and system is amazing. My clients think it's so much easier than the system I was using before.",
        author: "<strong>Martina C.</strong>, Owner of Martina Caruso Makeup and Hair,",
        authorDescription: "former Vagaro User who switched to Mangomint",
      },
    ],
  },
  "switch-from-zenoti": {
    pageHeader: {
      heading: "Mangomint vs. Zenoti",
      subheading:
        "Mangomint is the #1 rated salon & spa software by Capterra and G2. Here's why it might be the right choice for you.",
    },
    competitor: {
      name: "Zenoti",
      logo: ZenotiLogo,
    },
    rows: [
      {
        col1: "Great for",
        col2: "Growing, human-sized* salons and spas <cite>*1-10 locations</cite>",
        col3: "Enterprise-sized salon and spas with many locations",
      },
      {
        col1: "Top Features",
        col2: "Intuitive, streamlined features that save you time running your business",
        col3: "Extensive feature set, but with a steep learning curve",
      },
      {
        col1: "Support",
        col2: "U.S.-based support from real (human) product experts, responding in under 10 minutes",
        col3: "Primarily ticket-based support (or non-human AI bot), with slower response times",
      },
      {
        col1: "Bottom Line",
        col2: "Solutions that work from day 1 for bookings, payments, reporting, and more-without tech headaches",
        col3: "Extensive system for large businesses needing heavy customization (and can manage complexity)",
      },
    ],
    table: {
      heading: "Want a deeper dive?",
      subheading: "Here's how Mangomint and Zenoti compare based on real user feedback",
      mangomintName: "Mangomint",
      competitorName: "Zenoti",
      rows: [
        {
          category: "Overall Rating",
          mangomint: { capterra: "4.9", g2: "4.9" },
          competitor: { capterra: "4.4", g2: "4.3" },
        },
        {
          category: "Ease of Use",
          mangomint: { capterra: "4.9" },
          competitor: { capterra: "4.4" },
        },
        {
          category: "Customer Service",
          mangomint: { capterra: "5.0" },
          competitor: { capterra: "4.6" },
        },
        {
          category: "Pricing",
          mangomint: "Starting at $165",
          competitor: "Starting at $400 per month",
        },
        {
          category: "Transaction Processing Fees",
          mangomint: "In person: 2.45% + 15¢\nVirtual: 2.90% + 20¢/transaction",
          competitor: "In person: 2.45% + 10¢\nVirtual: 2.95% + 10¢/transaction",
        },
        {
          category: "Contracts",
          mangomint: {
            desktop: "No contracts. Open data ownership-available to you anytime",
            mobile: "No contracts. Open data ownership.",
          },
          competitor: "One-year contract required.",
        },
        {
          category: "Getting Started",
          mangomint: {
            desktop: "Free data transfer. Dedicated manager assigned for 1:1 sessions, plus access to Learning Center.",
            mobile: "Free data transfer. 1:1 onboarding manager.",
          },
          competitor: "Zenoti University training available.",
        },
      ],
    },
    quotes: [
      {
        quote:
          "I love Mangomint! It's easy to use and really helps keep my business organized. I love how easy the email templates are as well. My clients love the two-way texting for keeping in contact.",
        author:
          "<strong>Sabrina C.</strong> via <a href='https://www.capterra.com/p/187593/Mangomint/#Capterra___6770211' target='_blank' rel='noopener'>Capterra</a>,",
        authorDescription: "Former Zenoti user who switched to Mangomint",
      },
      {
        quote:
          "The support and the features that Mangomint has has allowed us to be as successful as we are, and we recognize that. I recommend it to other owners.",
        author: "<strong>Clay M.</strong>, Atomic Tattoos",
      },
    ],
  },
  "switch-from-fresha": {
    pageHeader: {
      heading: "Mangomint vs. Fresha",
      subheading:
        "Mangomint is the #1 rated salon & spa software by Capterra and G2. Here's why it might be the right choice for you.",
    },
    competitor: {
      name: "Fresha",
      logo: FreshaLogo,
    },
    rows: [
      {
        col1: "Great for",
        col2: "Sophisticated businesses looking to grow",
        col3: "Small businesses looking for a minimal solution",
      },
      {
        col1: "Top Features",
        col2: "Premium design and usability. Optimized for speed and efficiency. No hidden fees.",
        col3: "Subscription-free and low cost options with a large marketplace, but lacking customization",
      },
      {
        col1: "Support",
        col2: "U.S.-based support from real (human) product experts, responding in under 10 minutes",
        col3: "Limited support via email, operating only between 7AM-7PM",
      },
      {
        col1: "Bottom Line",
        col2: "Advanced tools and automation flows to strengthen client retention, cut costs, and increase profits",
        col3: "Marketplace for acquiring new clients-but at a 20% commission cost (and a lack of brand control)",
      },
    ],
    table: {
      heading: "Want a deeper dive?",
      subheading: "Here's how Mangomint and Fresha compare based on real user feedback",
      mangomintName: "Mangomint",
      competitorName: "Fresha",
      rows: [
        {
          category: "Overall Rating",
          mangomint: { capterra: "4.9", g2: "4.9" },
          competitor: { capterra: "4.8", g2: "4.4" },
        },
        {
          category: "Ease of Use",
          mangomint: { capterra: "4.9" },
          competitor: { capterra: "4.9" },
        },
        {
          category: "Customer Service",
          mangomint: { capterra: "5.0" },
          competitor: { capterra: "4.8" },
        },
        {
          category: "Pricing",
          mangomint: "Starting at $165-average $245 per month",
          competitor: "Starting from free listing (with 20% booking commission)-average $130 per month",
        },
        {
          category: "Transaction Processing Fees",
          mangomint: "In person: 2.45% + 15¢/transaction\nVirtual: 2.90% + 20¢/transaction",
          competitor: "In person: 2.29% + 20¢/transaction (+10¢/tap)\nVirtual: 2.79% + 20¢/transaction",
        },
        {
          category: "Contracts",
          mangomint: {
            desktop: "No contracts. Open data ownership-available to you anytime",
            mobile: "No contracts. Open data ownership.",
          },
          competitor: "No contracts",
        },
        {
          category: "Getting Started",
          mangomint: {
            desktop: "Free data transfer. Dedicated manager assigned for 1:1 sessions, plus access to Learning Center.",
            mobile: "Free data transfer. 1:1 onboarding manager.",
          },
          competitor: {
            desktop:
              "Free marketplace listing to get started. Data transfer available ranging from free to higher complexity paid plans",
            mobile: "Free marketplace listing to get started",
          },
        },
      ],
    },
    quotes: [
      {
        quote:
          "Exceptional customer service, and beyond that-awesome features, like customizations, Express Booking™, two-way texting and much more! [Alternatives] charged 20% per text message/email sent and we assumed we would quickly meet a high charge while paying extra",
        author:
          "<strong>Melissa R.</strong> via <a href='https://www.capterra.com/p/187593/Mangomint/#Capterra___6770211' target='_blank' rel='noopener'>Capterra</a>",
      },
      {
        quote:
          "Mangomint is one of the cleanest, easiest-to-use salon software platforms we've worked with. When we switched from our previous software, our bookings increased by 20%. That alone made the transition worth it.",
        author:
          "<strong>S. Franky H.</strong> via <a href='https://www.capterra.com/p/187593/Mangomint/#Capterra___6770211' target='_blank' rel='noopener'>Capterra</a>, We Fucking Love Your Hair",
      },
    ],
  },
  "switch-from-phorest": {
    pageHeader: {
      heading: "Mangomint vs. Phorest",
      subheading:
        "Mangomint is the #1 rated salon & spa software by Capterra and G2. Here's why it might be the right choice for you.",
    },
    competitor: {
      name: "Phorest",
      logo: PhorestLogo,
    },
    rows: [
      {
        col1: "Great for",
        col2: "Growing businesses looking for software that balances functionality and ease",
        col3: "Multi-provider businesses looking for a basic all-in-one solution",
      },
      {
        col1: "Top Features",
        col2: "Flexible solutions for booking, reporting, marketing, and more-available across devices",
        col3: "Focus on loyalty, referrals and reporting-but slow-to-update and limitations by device type",
      },
      {
        col1: "Support",
        col2: "U.S.-based support from real (human) product experts, responding in under 10 minutes",
        col3: "Dedicated Salon Manager-with wait times up to 72 hours",
      },
      {
        col1: "Bottom Line",
        col2: "Customizable, modern features in a clean interface",
        col3: "Emphasis on client retention-but an outdated interface and limited customizations",
      },
    ],
    table: {
      heading: "Want a deeper dive?",
      subheading: "Here's how Mangomint & Phorest compare based on real user feedback",
      mangomintName: "Mangomint",
      competitorName: "Phorest",
      rows: [
        {
          category: "Overall Rating",
          mangomint: { capterra: "4.9", g2: "4.9" },
          competitor: { capterra: "4.8", g2: "4.4" },
        },
        {
          category: "Ease of Use",
          mangomint: { capterra: "4.9" },
          competitor: { capterra: "4.7" },
        },
        {
          category: "Customer Service",
          mangomint: { capterra: "5.0" },
          competitor: { capterra: "4.8" },
        },
        {
          category: "Pricing",
          mangomint: "Starting at $165-average $245 per month",
          competitor: "Starting at $99-Must request quote for pricing",
        },
        {
          category: "Transaction Processing Fees",
          mangomint: "In person: 2.45% + 15¢/transaction\nVirtual: 2.90% + 20¢/transaction",
          competitor: "In person: 2.6% + 10¢/transaction\nVirtual: 3.1% + 15¢/transaction",
        },
        {
          category: "Contracts",
          mangomint: {
            desktop: "No contracts. Open data ownership-available to you anytime",
            mobile: "No contracts. Open data ownership.",
          },
          competitor: "One-year contract required",
        },
        {
          category: "Getting Started",
          mangomint: {
            desktop: "Free data transfer. Dedicated manager assigned for 1:1 sessions, plus access to Learning Center.",
            mobile: "Free data transfer. 1:1 onboarding manager.",
          },
          competitor: {
            desktop: "Onboarding and setup included with plan pricing",
            mobile: "Onboarding and setup included.",
          },
        },
      ],
    },
    quotes: [
      {
        quote:
          "My overall experience is a 10/10. Our onboarding specialist was incredible and always there to help no matter the time of day or how simple my question was. Mangomint is very elegant and easy to use.",
        author:
          "<strong>Tyler G.</strong> via <a href='https://www.capterra.com/p/187593/Mangomint/#Capterra___6770211' target='_blank' rel='noopener'>Capterra</a>,",
        authorDescription: "Former Phorest user who switched to Mangomint",
      },
      {
        quote:
          "Mangomint is one of the cleanest, easiest-to-use salon software platforms we've worked with. When we switched from our previous software, our bookings increased by 20%. That alone made the transition worth it.",
        author:
          "<strong>S. Franky H.</strong> via <a href='https://www.capterra.com/p/187593/Mangomint/#Capterra___6770211' target='_blank' rel='noopener'>Capterra</a>, We Fucking Love Your Hair",
      },
    ],
  },
  "switch-from-boulevard": {
    pageHeader: {
      heading: "Mangomint vs. Boulevard",
      subheading:
        "Mangomint is the #1 rated salon & spa software by Capterra and G2. Here's why it might be the right choice for you.",
    },
    competitor: {
      name: "Boulevard",
      logo: BoulevardLogo,
      height: "-5px",
    },
    rows: [
      {
        col1: "Great for",
        col2: "Sophisticated teams looking to grow",
        col3: "Larger businesses seeking a marketing-focused tool",
      },
      {
        col1: "Top Features",
        col2: "Customizable features and beautiful interface with full functionality on desktop and mobile",
        col3: "Strong client management - but otherwise non-customizable features and significant mobile limitations",
      },
      {
        col1: "Support",
        col2: "U.S.based support from real (human) product experts, responding in under 10 minutes",
        col3: "Chat bot-based service. Human-based support <i>if</i> requested (response times up to 1 day)",
      },
      {
        col1: "Bottom Line",
        col2: "Modern features from online booking to client communications-with no contracts",
        col3: "Solid feature set but only in structured, contract-based plans",
      },
    ],
    table: {
      heading: "Want a deeper dive?",
      subheading: "Here's how Mangomint & Boulevard compare based on real user feedback.",
      mangomintName: "Mangomint",
      competitorName: "Boulevard",
      rows: [
        {
          category: "Overall Rating",
          mangomint: { capterra: "4.9", g2: "4.9" },
          competitor: { capterra: "4.6", g2: "4.3" },
        },
        {
          category: "Ease of Use",
          mangomint: { capterra: "4.9" },
          competitor: { capterra: "4.6" },
        },
        {
          category: "Customer Service",
          mangomint: { capterra: "5.0" },
          competitor: { capterra: "4.7" },
        },
        {
          category: "Pricing",
          mangomint: "Starting at $165-average $245 per month",
          competitor: "Starting at $176-average $425 per month",
        },
        {
          category: "Transaction Processing Fees",
          mangomint: "In person: 2.45% + 15¢/transaction\nVirtual: 2.90% + 20¢/transaction",
          competitor: "In person: 2.6% + 10¢/transaction\nVirtual: 3.6% + 10¢/transaction",
        },
        {
          category: "Contracts",
          mangomint: {
            desktop: "No contracts & open data ownership-available to you anytime",
            mobile: "No contracts. Open data ownership.",
          },
          competitor: "One-year contract required.",
        },
        {
          category: "Getting Started",
          mangomint: {
            desktop: "Free data transfer. Dedicated manager assigned for 1:1 sessions, plus access to Learning Center.",
            mobile: "Free data transfer. 1:1 onboarding manager.",
          },
          competitor: {
            desktop: "Onboarding fees starting at $495. Partial and full data imports available for a fee.",
            mobile: "Onboarding fees starting at $495.",
          },
        },
      ],
    },
    quotes: [
      {
        quote: "What I liked about Mangomint the most is that 24 hours later, I was up and running",
        author: "<strong>Sundar N.</strong>, Owner of Beauty Within Medspa,",
        authorDescription: "Former Boulevard user who switched to Mangomint",
      },
      {
        quote:
          "The ExpressBooking feature has been a complete game changer for us [booking clients over the phone]. I just send a text and the client fills it out. It makes us look super professional.",
        author: "<strong>Harry D.</strong>, Owner of Skin Plus Beauty Medspa,",
        authorDescription: "Former Boulevard user",
      },
    ],
  },
  "switch-from-milano": {
    pageHeader: {
      heading: "Mangomint vs. Milano",
      subheading:
        "Mangomint is the #1 rated salon & spa software by Capterra and G2. Here's why it might be the right choice for you.",
    },
    competitor: {
      name: "Milano",
      logo: MilanoLogo,
      height: "12.5px",
    },
    rows: [
      {
        col1: "Great for",
        col2: "Modern businesses looking to grow with an all-in-one solution",
        col3: "Businesses more comfortable with basic tools and legacy software",
      },
      {
        col1: "Top Features",
        col2: "Premium design and usability. Complete solution from online booking to reporting to marketing",
        col3: "Legacy look and feel with basic booking and POS. Outdated flows and automations for marketing tools",
      },
      {
        col1: "Support",
        col2: "U.S.-based support from real (human) product experts, responding in under 10 minutes",
        col3: "Monday to Saturday support team, with slower response times",
      },
      {
        col1: "Bottom Line",
        col2: "A faster, smarter solution to run your salon or spa-with tools that scale your business",
        col3: "Familiar legacy system that covers basic needs but struggles to keep up with modern demands",
      },
    ],
    table: {
      heading: "Want a deeper dive?",
      subheading: "Here's how Mangomint and Milano compare based on real user feedback",
      mangomintName: "Mangomint",
      competitorName: "Milano",
      rows: [
        {
          category: "Overall Rating",
          mangomint: { capterra: "4.9", g2: "4.9" },
          competitor: { capterra: "n/a", g2: "n/a" },
        },
        {
          category: "Ease of Use",
          mangomint: { capterra: "4.9" },
          competitor: { capterra: "n/a" },
        },
        {
          category: "Customer Service",
          mangomint: { capterra: "5.0" },
          competitor: { capterra: "n/a" },
        },
        {
          category: "Pricing",
          mangomint: "Starting at $165-average $245 per month",
          competitor: "Starting at $39.95 for online booking. Contact Milano for additional pricing.",
        },
        {
          category: "Contracts",
          mangomint: {
            desktop: "No contracts. Open data ownership-available to you anytime",
            mobile: "No contracts. Open data ownership.",
          },
          competitor: "Monthly contract",
        },
        {
          category: "Getting Started",
          mangomint: {
            desktop: "Free data transfer. Dedicated manager assigned for 1:1 sessions, plus access to Learning Center",
            mobile: "Free data transfer. 1:1 onboarding manager.",
          },
          competitor: {
            desktop: "One-time $495 fee to begin using Milano",
            mobile: "One-time $495 fee",
          },
        },
      ],
    },
    quotes: [
      {
        quote:
          "Overall, our experience with Mangomint has been really positive. It's a sleek, user-friendly platform that helps us run our studio more efficiently, and we love that the team is responsive to feedback.",
        author:
          "<strong>Mercedes M.</strong> via <a href='https://www.capterra.com/p/187593/Mangomint/#Capterra___6770211' target='_blank' rel='noopener'>Capterra</a>",
      },
      {
        quote:
          "I've used 5 different salon softwares and [Mangomint] onboarding was the absolute easiest I've ever experienced. The customer service is top-notch, and the software is aesthetically pleasing for us and our clients, and super easy to use.",
        author:
          "<strong>Sarah E.</strong> via <a href='https://www.capterra.com/p/187593/Mangomint/#Capterra___6770211' target='_blank' rel='noopener'>Capterra</a>",
      },
    ],
  },
  "switch-from-meevo": {
    pageHeader: {
      heading: "Mangomint vs. Meevo",
      subheading:
        "Mangomint is the #1 rated salon & spa software by Capterra and G2. Here's why it might be the right choice for you.",
    },
    competitor: {
      name: "Meevo",
      logo: MeevoLogo,
      height: "-3.5px",
    },
    rows: [
      {
        col1: "Great for",
        col2: "Growing businesses that want premium software without the learning curve",
        col3: "Teams who want deep customization and don't mind tech-heavy tools",
      },
      {
        col1: "Top Features",
        col2: "Clean interface, fast workflows, and fewer clicks to get more done in less time",
        col3: "Powerful reporting dashboards, but expect a steep learning curve and lots of setup time",
      },
      {
        col1: "Support",
        col2: "U.S.-based support from real (human) product experts, responding in under 10 minutes",
        col3: "Chat bot-based service. Human-based support if requested (response times up to 1 day)",
      },
      {
        col1: "Bottom Line",
        col2: "Smart automations and sleek scheduling that don't require an IT degree",
        col3: "Custom dashboards and widgets but requires more time and tech know-how to manage",
      },
    ],
    table: {
      heading: "Want a deeper dive?",
      subheading: "Here's how Mangomint and Meevo compare based on real user feedback",
      mangomintName: "Mangomint",
      competitorName: "Meevo",
      rows: [
        {
          category: "Overall Rating",
          mangomint: { capterra: "4.9", g2: "4.9" },
          competitor: { capterra: "4.4", g2: "3.5" },
        },
        {
          category: "Ease of Use",
          mangomint: { capterra: "4.9" },
          competitor: { capterra: "4.3" },
        },
        {
          category: "Customer Service",
          mangomint: { capterra: "5.0" },
          competitor: { capterra: "4.6" },
        },
        {
          category: "Pricing",
          mangomint: "Starting at $165-average $245 per month",
          competitor: "Starting at $139-Must request quote for pricing",
        },
        {
          category: "Transaction Processing Fees",
          mangomint: "In person: 2.45% + 15¢/transaction\nVirtual: 2.90% + 20¢/transaction",
          competitor: "In person: 2.6% + 10¢/transaction\nVirtual: 3.5% + 15¢/transaction",
        },
        {
          category: "Contracts",
          mangomint: {
            desktop: "No contracts. Open data ownership-available to you anytime",
            mobile: "No contracts. Open data ownership.",
          },
          competitor: "One year contract required.",
        },
        {
          category: "Getting Started",
          mangomint: {
            desktop: "Free data transfer. Dedicated manager assigned for 1:1 sessions, plus access to Learning Center.",
            mobile: "Free data transfer. 1:1 onboarding manager.",
          },
          competitor: "Onboarding and training packages available",
        },
      ],
    },
    quotes: [
      {
        quote:
          "[Mangomint] has been amazing! Very easy to onboard and they were with me every step of the way. They are the easiest booking software I have ever worked with. You have me as a customer as long as I own my spa!",
        author:
          "<strong>Michelle D.</strong> via <a href='https://www.capterra.com/p/187593/Mangomint/#Capterra___6770211' target='_blank' rel='noopener'>Capterra</a>",
      },
      {
        quote:
          "The software is easy. The onboarding is efficient. The subscription is saving me money not only in its overall fees but by making it so I can eliminate additional services I was forced to run my business.",
        author:
          "<strong>Sarah E.</strong> via <a href='https://www.capterra.com/p/187593/Mangomint/#Capterra___6770211' target='_blank' rel='noopener'>Capterra</a>,",
        authorDescription: "Former Meevo user who switched to Mangomint",
      },
    ],
  },
  "switch-from-rosy": {
    pageHeader: {
      heading: "Mangomint vs. Rosy",
      subheading:
        "Mangomint is the #1 rated salon & spa software by Capterra and G2. Here's why it might be the right choice for you.",
    },
    competitor: {
      name: "Rosy",
      logo: RosyLogo,
      height: "-2.5px",
    },
    rows: [
      {
        col1: "Great for",
        col2: "Growing salons & spas that need speed, style, and smart automation",
        col3: "Small salons looking for a basic, budget-friendly setup",
      },
      {
        col1: "Top Features",
        col2: "Polished, powerful tools for booking, client retention, automation, and more",
        col3: "Simple, affordable scheduling and management tools-but outdated interface and limited advanced features",
      },
      {
        col1: "Support",
        col2: "U.S.-based support from real (human) product experts, responding in under 10 minutes",
        col3: "Slow and less tailored support available via chat or phone",
      },
      {
        col1: "Bottom Line",
        col2: "All-in-one software designed to scale without slowing you down",
        col3: "Great entry-level option, but lacks the horsepower to support growing businesses",
      },
    ],
    table: {
      heading: "Want a deeper dive?",
      subheading: "Here's how Mangomint and Rosy compare based on real user feedback",
      mangomintName: "Mangomint",
      competitorName: "Rosy",
      rows: [
        {
          category: "Overall Rating",
          mangomint: { capterra: "4.9", g2: "4.9" },
          competitor: { capterra: "4.6", g2: "4.6" },
        },
        {
          category: "Ease of Use",
          mangomint: { capterra: "4.9" },
          competitor: { capterra: "4.7" },
        },
        {
          category: "Customer Service",
          mangomint: { capterra: "5.0" },
          competitor: { capterra: "4.4" },
        },
        {
          category: "Pricing",
          mangomint: "Starting at $165/month (up to 10 users)",
          competitor: "Starting at $39/month for a single user",
        },
        {
          category: "Transaction Processing Fees",
          mangomint: "In person: 2.45% + 15¢/transaction\nVirtual: 2.90% + 20¢/transaction",
          competitor: "RosyPay rates available on request.",
        },
        {
          category: "Contracts",
          mangomint: {
            desktop: "No contracts. Open data ownership-available to you anytime",
            mobile: "No contracts. Open data ownership.",
          },
          competitor: "No contracts",
        },
        {
          category: "Getting Started",
          mangomint: {
            desktop: "Free data transfer. Dedicated manager assigned for 1:1 sessions, plus access to Learning Center.",
            mobile: "Free data transfer. 1:1 onboarding manager.",
          },
          competitor: {
            desktop: "Free data transfer and dedicated manager assigned",
            mobile: "Free data transfer. Dedicated manager.",
          },
        },
      ],
    },
    quotes: [
      {
        quote:
          "[Mangomint's] super easy to navigate for my extremely busy job. Makes organizing and prioritizing much much more efficient! [I love] the detailed customization for each business",
        author:
          "<strong>Ellie K.</strong> via <a href='https://www.capterra.com/p/187593/Mangomint/#Capterra___6770211' target='_blank' rel='noopener'>Capterra</a>,",
        authorDescription: "Former Rosy user who switched to Mangomint",
      },
      {
        quote:
          "From our staff, to our clients, everyone has seen it as an upgrade for our business. [Mangomint] has made us more efficient as a company and we cannot express enough gratitude for their quality customer care.",
        author:
          "<strong>Megan C.</strong> via <a href='https://www.capterra.com/p/187593/Mangomint/#Capterra___6770211' target='_blank' rel='noopener'>Capterra</a>",
      },
    ],
  },
  "switch-from-booker": {
    pageHeader: {
      heading: "Mangomint vs. Booker",
      subheading:
        "Mangomint is the #1 rated salon & spa software by Capterra and G2. Here's why it might be the right choice for you.",
    },
    competitor: {
      name: "Booker",
      logo: BookerLogo,
    },
    rows: [
      {
        col1: "Great for",
        col2: "Salons & spas that want effortless tools and zero hidden fees",
        col3: "Businesses that want lots of features and don't mind extra costs",
      },
      {
        col1: "Top Features",
        col2: "Sleek, fast, and designed for smooth day-to-day operations-no clunky extras",
        col3: "Diverse feature set, but known for slow load times and surprise fees",
      },
      {
        col1: "Support",
        col2: "U.S.-based support from real (human) product experts, responding in under 10 minutes",
        col3: "U.S.-based customer support only available to Ultimate plans (starting at $469/month)-outsourced for lower-end plans",
      },
      {
        col1: "Bottom Line",
        col2: "Advanced automation that cuts costs and boosts profits-without nickel-and-diming you",
        col3: "Expansive feature set, but expect to pay extra for things like text reminders",
      },
    ],
    table: {
      heading: "Want a deeper dive?",
      subheading: "Here's how Mangomint and Booker compare based on real user feedback",
      mangomintName: "Mangomint",
      competitorName: "Booker",
      rows: [
        {
          category: "Overall Rating",
          mangomint: { capterra: "4.9" },
          competitor: { capterra: "4.1" },
        },
        {
          category: "Ease of Use",
          mangomint: { capterra: "4.9" },
          competitor: { capterra: "4.1" },
        },
        {
          category: "Customer Service",
          mangomint: { capterra: "5.0" },
          competitor: { capterra: "4.1" },
        },
        {
          category: "Pricing",
          mangomint: "Starting at $165-average $245 per month",
          competitor: "Starting at $139-average $470 per month",
        },
        {
          category: "Transaction Processing Fees",
          mangomint: "In person: 2.45% + 15¢/transaction\nVirtual: 2.90% + 20¢/transaction",
          competitor: "In person: 2.75% (plus additional fees in CAD)\nVirtual: 3.5% + 15¢/transaction",
        },
        {
          category: "Contracts",
          mangomint: {
            desktop: "No contracts. Open data ownership-available to you anytime",
            mobile: "No contracts. Open data ownership.",
          },
          competitor: "Minimum one-year contract required",
        },
        {
          category: "Getting Started",
          mangomint: {
            desktop: "Free data transfer. Dedicated manager assigned for 1:1 sessions, plus access to Learning Center.",
            mobile: "Free data transfer. 1:1 onboarding manager.",
          },
          competitor: "Onboarding mostly provided via training video library",
        },
      ],
    },
    quotes: [
      {
        quote:
          "From the very beginning it's been a smooth transition. The whole platform is user friendly and they have a lot to offer. You get a lot more for the money. Since switching, we've been so happy with the ease of use for staff and clients.",
        author:
          "<strong>Kristen P.</strong> via <a href='https://www.capterra.com/p/187593/Mangomint/#Capterra___6770211' target='_blank' rel='noopener'>Capterra</a>,",
        authorDescription: "Former Booker user who switched to Mangomint",
      },
      {
        quote:
          "The setup and migration process was very easy. The intuitive software has been a dream. The end user experience has been top notch. Clients really love it! [Our former software] was very overpriced and its platform was outdated.",
        author:
          "<strong>Elena M.</strong> via <a href='https://www.capterra.com/p/187593/Mangomint/#Capterra___6770211' target='_blank' rel='noopener'>Capterra</a>,",
        authorDescription: "Former Booker user",
      },
    ],
  },
  "mangomint-med-spa-software-aesthetic-record": {
    pageHeader: {
      heading: "Mangomint vs. Aesthetic Record",
      subheading:
        "Mangomint is the #1 rated salon & spa software by Capterra and G2. Here's why it might be the right choice for you.",
    },
    competitor: {
      name: "Aesthetic Record",
      logo: AestheticRecordLogo,
      height: "-5px",
    },
    rows: [
      {
        col1: "Great for",
        col2: "Sophisticated med spas looking to grow",
      },
      {
        col1: "Top Features",
        col2: "Lightning-fast, beautifully designed with smart features like <a href='https://www.mangomint.com/features/express-booking/' target='_blank' rel='noopener'>Express Booking</a>™ and HIPAA-compliant <a href='https://www.mangomint.com/features/integrated-forms/' target='_blank' rel='noopener'>forms</a>, built with med spas in mind",
      },
      {
        col1: "Support",
        col2: "U.S.-based support from real (human) experts with actual industry experience, responding in under 10 minutes",
      },
      {
        col1: "Bottom Line",
        col2: "Intuitive, all-in-one software that helps you cut costs, save time, and increase profits, without the medical complexity",
      },
    ],
    table: {
      heading: "How Mangomint Stacks Up",
      subheading: "Here's how Mangomint & Aesthetic Record compare based on real user feedback",
      mangomintName: "Mangomint",
      competitorName: "Aesthetic Record",
      rows: [
        {
          category: "Overall Rating",
          mangomint: { capterra: "4.9", g2: "4.9" },
          competitor: { capterra: "3.4", g2: "5.0" },
        },
        {
          category: "Ease of Use",
          mangomint: { capterra: "4.9" },
          competitor: { capterra: "3.4" },
        },
        {
          category: "Customer Service",
          mangomint: { capterra: "5.0" },
          competitor: { capterra: "3.4" },
        },
        {
          category: "HIPAA-Compliant?",
          mangomint: true,
          competitor: true,
        },
        {
          category: "Pricing",
          mangomint: "Starting at $165-average $245 per month",
          competitor: "Starting at $12/month/user-average $120 per month",
        },
        {
          category: "Contracts",
          mangomint: {
            desktop: "No contracts. Open data ownership-available to you anytime",
            mobile: "No contracts. Open data ownership.",
          },
          competitor: "No contracts.",
        },
        {
          category: "Getting Started",
          mangomint: {
            desktop: "Free data transfer. Dedicated manager assigned for 1:1 sessions.",
            mobile: "Free data transfer. 1:1 onboarding manager.",
          },
          competitor: {
            desktop:
              "$399 startup & onboarding fees. Training sessions with account setup available for additional fee.",
            mobile: "$399 startup & onboarding fees.",
          },
        },
      ],
    },
    quotes: [
      {
        quote:
          "Mangomint has been game changer for our office. We are able to see and communicate with patients from all offices and with ease of use creating and scheduling appointments, it has made it seamless.",
        author:
          "<strong>Katie W.</strong> via <a href='https://www.capterra.com/p/187593/Mangomint/#Capterra___6770211' target='_blank' rel='noopener'>Capterra</a>,",
        authorDescription: "Medical Office Manager",
      },
      {
        quote:
          "The Express Booking™ feature has been a complete game changer for us [booking clients over the phone]. I just send a text and the client fills it out. It makes us look super professional.",
        author: "<strong>Harry D.</strong>, Owner of Skin Plus Beauty Medspa",
      },
    ],
  },
  "mangomint-med-spa-software-aestheticspro": {
    pageHeader: {
      heading: "Mangomint vs. AestheticsPro",
      subheading:
        "Mangomint is the #1 rated salon & spa software by Capterra and G2. Here's why it might be the right choice for you.",
    },
    competitor: {
      name: "AestheticsPro",
      logo: AestheticsProLogo,
    },
    rows: [
      {
        col1: "Great for",
        col2: "Modern med spas that want HIPAA-compliant, next-level tools",
        col3: "Med spas that need EMR and clinical documentation",
      },
      {
        col1: "Top Features",
        col2: "Streamlined design, fast checkouts, and effortless booking-built for medspas",
        col3: "Focuses on medical charting and clinical use, not med spa-friendly UX",
      },
      {
        col1: "Support",
        col2: "U.S.-based support from real (human) product experts, responding in under 10 minutes",
        col3: "Support available via phone and email, but less personalized",
      },
      {
        col1: "Bottom Line",
        col2: "Powerful automation tools to boost client retention, cut costs, and increase profits-without legacy software complexities",
        col3: "Better for medical workflows than client experience or day-to-day usability",
      },
    ],
    table: {
      heading: "Want a deeper dive?",
      subheading: "Here's how Mangomint & AestheticsPro compare based on real user feedback",
      mangomintName: "Mangomint",
      competitorName: "AestheticsPro",
      rows: [
        {
          category: "Overall Rating",
          mangomint: { capterra: "4.9", g2: "4.9" },
          competitor: { capterra: "4.4", g2: "4.1" },
        },
        {
          category: "Ease of Use",
          mangomint: { capterra: "4.9" },
          competitor: { capterra: "4.2" },
        },
        {
          category: "Customer Service",
          mangomint: { capterra: "5.0" },
          competitor: { capterra: "4.5" },
        },
        {
          category: "HIPAA-compliant?",
          mangomint: true,
          competitor: true,
        },
        {
          category: "Pricing",
          mangomint: "Starting at $165-average $245 per month",
          competitor: "Starting at $75/user/month-average price $200 per month",
        },
        {
          category: "Contracts",
          mangomint: {
            desktop: "No contracts. Open data ownership-available to you anytime",
            mobile: "No contracts. Open data ownership.",
          },
          competitor: "Monthly contract required",
        },
        {
          category: "Getting Started",
          mangomint: {
            desktop: "Free data transfer. Dedicated manager assigned for 1:1 sessions, plus access to Learning Center.",
            mobile: "Free data transfer. 1:1 onboarding manager.",
          },
          competitor: "Implementation plan and onboarding, including one-on-one sessions.",
        },
      ],
    },
    quotes: [
      {
        quote:
          "From transferring my data over to learning how to use all the functions, [Mangomint is the] LEAST stressful part of my business. The customizable settings make it so easy to manage my services, business info, and payment processing all in one place.",
        author:
          "<strong>Tiffany M.</strong> via <a href='https://www.capterra.com/p/187593/Mangomint/#Capterra___6770211' target='_blank' rel='noopener'>Capterra</a>,",
        authorDescription: "Former AestheticsPro user who switched to Mangomint",
      },
      {
        quote:
          "What I liked about Mangomint the most is that 24 hours later, I was up and running. The team handled everything. I know it took a lot of time and effort-and I was hooked.",
        author: "<strong>Sundar N.</strong>, Beauty Within Medspa",
      },
    ],
  },
  "switch-from-square": {
    pageHeader: {
      heading: "Mangomint vs. Square",
      subheading:
        "Mangomint is the #1 rated salon & spa software by Capterra and G2. Here's why it might be the right choice for you.",
    },
    competitor: {
      name: "Square",
      logo: SquareLogo,
    },
    rows: [
      {
        col1: "Great for",
        col2: "Growing teams needing premium features built specifically for salons & spas",
        col3: "Solopreneurs or small teams looking for broad features",
      },
      {
        col1: "Top Features",
        col2: "Industry-specific features like client profiles & intake forms in a sleek, easy-to-use interface",
        col3: "Wide variety of features, but not built for salons and spas",
      },
      {
        col1: "Support",
        col2: "U.S.-based support from real (human) product experts, responding in under 10 minutes",
        col3: "No live chat available. Mostly help desk and forum-based",
      },
      {
        col1: "Bottom Line",
        col2: "Features actually built for growing salons, spas, and med spas",
        col3: "Lots of features for starting out but limited for businesses looking to grow",
      },
    ],
    table: {
      heading: "Want a deeper dive?",
      subheading: "Here's how Mangomint and Square compare based on real user feedback",
      mangomintName: "Mangomint",
      competitorName: "Square",
      rows: [
        {
          category: "Overall Rating",
          mangomint: { capterra: "4.9", g2: "4.9" },
          competitor: { capterra: "4.5", g2: "4.3" },
        },
        {
          category: "Ease of Use",
          mangomint: { capterra: "4.9" },
          competitor: { capterra: "4.5" },
        },
        {
          category: "Customer Service",
          mangomint: { capterra: "5.0" },
          competitor: { capterra: "4.3" },
        },
        {
          category: "Pricing",
          mangomint: "Starting at $165—average $245 per month",
          competitor: "Starting from free base plan for solos—average $45 per month",
        },
        {
          category: "Transaction Processing Fees",
          mangomint: "In person: 2.45% + 15¢/transaction\nVirtual: 2.90% + 20¢/transaction",
          competitor: "In person: 2.6% + 10¢/transaction\nVirtual: 2.9% + 30¢/transaction",
        },
        {
          category: "Contracts",
          mangomint: {
            desktop: "No contracts & open data ownership—available to you anytime.",
            mobile: "No contracts. Open data ownership.",
          },
          competitor: "No contracts.",
        },
        {
          category: "Getting Started",
          mangomint: {
            desktop: "Free data transfer. Dedicated manager assigned for 1:1 sessions, plus access to Learning Center.",
            mobile: "Free data transfer. 1:1 onboarding manager.",
          },
          competitor: {
            desktop:
              "Predominantly self-guided. Additional support services available for a fee—contact sales for pricing.",
            mobile: "Predominantly self-guided.",
          },
        },
      ],
    },
    quotes: [
      {
        quote:
          "I run my whole business through Mangomint. Love the integrated forms and automatic notifications my clients get. We have implemented the new Flow feature and have gotten 10 new 5-star reviews in a week.",
        author: "<strong>Jess C.</strong> via Capterra,",
        authorDescription: "former Square user who switched to Mangomint",
      },
      {
        quote:
          "My team finds [Mangomint] very easy to navigate and we appreciate how easy it is to transition to Mangomint. They are constantly improving and launching new features. Highly recommend!",
        author: "<strong>Lisa B.</strong> via Capterra,",
        authorDescription: "med spa owner and former Square user who switched",
      },
    ],
  },
};

export default competitorData;
